const toTwoDigits = (value: number) => String(value).padStart(2, "0");

export const getTime = (date: Date = new Date()) =>
  `${toTwoDigits(date.getHours())}:${toTwoDigits(date.getMinutes())}:${toTwoDigits(
    date.getSeconds(),
  )}`;
